// Build a full SatuTim API URL from a bare OpenAPI path.
//
// OpenAPI spec paths are bare (e.g. `/workspaces`) but actual mounted routes
// live under `/api/v1/*`. The MCP executor server-side already handles this
// prefix; the playground client must do the same when constructing fetch URLs,
// cURL snippets, and IDE deeplinks.
//
// This is the single source of truth — all client-side URL builders go
// through `buildApiUrl()` so we never ship a request to `/workspaces` again.

export const API_BASE = (
    (import.meta as any)?.env?.VITE_API_BASE_URL as string | undefined
) || 'https://api.satutim.id';

export const API_PREFIX = '/api/v1';

/**
 * Prefix a bare OpenAPI path with `/api/v1` unless already prefixed.
 *
 * Examples:
 *   prefixApiPath('/workspaces') → '/api/v1/workspaces'
 *   prefixApiPath('/api/v1/workspaces') → '/api/v1/workspaces'
 *   prefixApiPath('workspaces') → '/api/v1/workspaces'
 *   prefixApiPath('/') → '/api/v1/'
 *   prefixApiPath('') → '/api/v1'
 */
export function prefixApiPath(path: string): string {
    if (!path) return API_PREFIX;
    // Already includes `/api/v1` somewhere at the start (with or without leading /).
    if (path.startsWith(API_PREFIX) || path.startsWith(`${API_PREFIX}/`)) return path;
    if (path.startsWith('/')) return `${API_PREFIX}${path}`;
    return `${API_PREFIX}/${path}`;
}

/**
 * Build a fully-qualified API URL: `https://api.satutim.id/api/v1<path>`.
 * Path may include path params and query string already substituted.
 */
export function buildApiUrl(path: string, baseUrl?: string): string {
    const base = baseUrl || API_BASE;
    return `${base}${prefixApiPath(path)}`;
}
